

export class SamplePoOrderDataModel {

    id: number;
    buyerName?: string;
    OrdersbuyerCode?: string;
    salesPerson?: string;
    itemResponsible?: string;
    deliveryTerms?: string;
    discountOne?: string;
    discountTwo?: string;
    packagingTrims?: string;
    deliveryMethod?: string;
    paymentMethod?: string;
    paymentTerms?: string;
    facility?: string;
    wareHouse?: string;
    pch?: string;
    buyerPoDate?: string;
    buyerPo?: string;
    shipmentType?: string;
    agent?: string;
    spQty?: string;
    createdUser?: string;
    updatedUser?: string;

    constructor(
        id: number,
        buyerName?: string,
        OrdersbuyerCode?: string,
        salesPerson?: string,
        itemResponsible?: string,
        deliveryTerms?: string,
        discountOne?: string,
        discountTwo?: string,
        packagingTrims?: string,
        deliveryMethod?: string,
        paymentMethod?: string,
        paymentTerms?: string,
        facility?: string,
        wareHouse?: string,
        pch?: string,
        buyerPoDate?: string,
        buyerPo?: string,
        shipmentType?: string,
        agent?: string,
        spQty?: string,
        createdUser?: string,
        updatedUser?: string,
    ) {
        this.id = id
        this.buyerName = buyerName
        this.OrdersbuyerCode = OrdersbuyerCode
        this.salesPerson = salesPerson
        this.itemResponsible = itemResponsible
        this.discountOne = discountOne
        this.discountTwo = discountTwo
        this.packagingTrims = packagingTrims
        this.deliveryMethod = deliveryMethod
        this.deliveryTerms = deliveryTerms
        this.paymentMethod = paymentMethod
        this.paymentTerms = paymentTerms
        this.facility = facility
        this.wareHouse = wareHouse
        this.pch = pch
        this.buyerPoDate = buyerPoDate
        this.buyerPo = buyerPo
        this.shipmentType = shipmentType
        this.agent = agent
        this.spQty = spQty
        this.createdUser=createdUser
        this.updatedUser=updatedUser
    }
}


